<template>
  <SideHeader :to="'/'" />

  <div id="refresh-container">
    <div class="pt-55">
      <Placeholder v-if="loading" />
      <div v-else style="background-color: white">
        <FixLimited v-if="isFreeCallsLimited" :freeCalls="freeCalls" />

        <div
          class="section"
          v-for="(cargo, index) in cargos"
          :key="cargo.id"
          :class="[
            index !== 0 ? 'mt-3 mb-3' : '',
            index === 0 && isFreeCallsExceeded ? 'pt-45' : '',
            index === 0 ? 'mt-3 mb-3' : '',
            // index === 0 && !isFreeCallsExceeded ? '' : '',
          ]"
        >
          <CardView :cargo="cargo" />
        </div>

        <button
          v-if="mode === 1 && loadingNext === 0"
          @click="nextLoadCargo"
          class="btn btn-success btn-block btn-lg"
        >
          نمایش بار های بیشتر کلیک کنید...
        </button>

        <button
          v-if="loadingNext === 1"
          class="btn btn-warning btn-lg btn-block"
          type="button"
          disabled
        >
          <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
          درحال بارگذاری ...
        </button>
      </div>
    </div>

    <a href="#" class="button goTop show">
      <ion-icon name="arrow-up-outline"></ion-icon>
    </a>
  </div>
</template>

<script>
import Placeholder from "@/components/Placeholder.vue";
import CardView from "@/views/cargo/components/CardView.vue";
import SideHeader from "@/components/SideHeader.vue";
import FixLimited from "@/components/FixLimited.vue";
import PullToRefresh from "pulltorefreshjs";
import axios from "axios";
import Swal from "sweetalert2";
import router from "@/router";

export default {
  name: "Master",
  components: {
    Placeholder,
    CardView,
    SideHeader,
    FixLimited
  },
  data() {
    return {
      cargos: [],
      loading: false,
      loadingNext: 0,
      loadingOff: 0,
      mode: 0,
      freeCalls: 'false',
      ptrInstance: null,
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      }
    };
  },
  computed: {
    isFreeCallsLimited() {
      return this.freeCalls !== 'false' && this.freeCalls >= 0 && this.freeCalls <= 6;
    },
    isFreeCallsExceeded() {
      return this.freeCalls !== 'false' && this.freeCalls > 6;
    }
  },
  methods: {
    initPullToRefresh() {
      if (this.ptrInstance) this.ptrInstance.destroy();
      this.ptrInstance = PullToRefresh.init({
        mainElement: '#refresh-container',
        onRefresh: () => this.getInitialCargos()
      });
    },
    async getInitialCargos() {
      try {
        this.loading = true;
        const { data } = await axios.get(`https://core.iran-tarabar.ir/api/driver/getNewLoadForDriver/0`, this.axiosConfig);

        if (this.$route.query.token) {
          axios.patch(`https://core.iran-tarabar.ir/api/driver/saveMyFireBaseToken`, {
            token: this.$route.query.token
          }, this.axiosConfig);
        }

        localStorage.setItem("tel", data.Tel);

        if (data.result === 0) {
          return Swal.fire({
            icon: "error",
            title: data.message,
            confirmButtonText: "تغییر ناوگان"
          }).then(result => {
            if (result.isConfirmed) router.push({ name: 'profile' });
          });
        }
        // console.log(data.loads);
        this.cargos = data.loads;
        this.freeCalls = data.freeCalls;
        this.restoreScroll();
        this.mode = 1;
        this.getNextCargo(); // Optional preload
      } catch (error) {
        if (error.response?.status === 401) {
          this.handleUnauthorized();
        }
      } finally {
        this.loading = false;
      }
    },
    async nextLoadCargo() {
      this.loadingNext = 1;
      try {
        const lastId = this.cargos.at(-1)?.id;
        const { data } = await axios.get(
          `https://core.iran-tarabar.ir/api/driver/getNewLoadForDriver/${lastId}`,
          this.axiosConfig
        );
        if (!data.loads?.length) {
          this.mode = 0;
          this.loadingOff = 1;
        } else {
          this.cargos.push(...data.loads);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingNext = 0;
      }
    },
    async getNextCargo() {
      try {
        const lastId = this.cargos.at(-1)?.id;
        const { data } = await axios.get(
          `https://core.iran-tarabar.ir/api/driver/getNewLoadForDriver/${lastId}`,
          this.axiosConfig
        );

        if (data.transactionCount >= 4 && localStorage.getItem("score") != 1) {
          this.promptRating();
        }

        if (!data.loads) {
          this.mode = 2;
        } else {
          this.cargos.push(...data.loads);
        }
      } catch (err) {
        console.error(err);
      }
    },
    promptRating() {
      Swal.fire({
        title: "ثبت امتیاز در بازار!",
        imageUrl: "assets/img/bazar-rate.jpg",
        imageWidth: 300,
        imageHeight: 150,
        imageAlt: "bazar app",
        confirmButtonText: "الان امتیاز میدهم!",
        cancelButtonText: "بعدا",
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        localStorage.setItem("score", 1);
        if (result.isConfirmed) {
          window.open("https://cafebazaar.ir/app/com.iran_tarabar.driver");
        }
      });
    },
    handleUnauthorized() {
      Swal.fire({
        title: "راننده محترم!",
        text: "شماره‌ای که با آن وارد برنامه شده‌اید، توسط دستگاه دیگری استفاده شده است!",
        icon: "error",
        confirmButtonText: "ورود مجدد!"
      }).then(() => {
        localStorage.clear();
        router.push({ name: 'login' });
      });
    },
    saveScrollPosition() {
      localStorage.setItem('scrollPosition', window.scrollY);
    },
    restoreScroll() {
      const pos = localStorage.getItem('scrollPosition');
      if (pos) {
        setTimeout(() => window.scrollTo(0, pos), 250);
      }
    }
  },
  beforeMount() {
    this.getInitialCargos();
  },
  mounted() {
    this.initPullToRefresh();
  },
  beforeRouteLeave(_, __, next) {
    this.saveScrollPosition();
    next();
  },
  beforeUnmount() {
    if (this.ptrInstance) this.ptrInstance.destroy();
  }
};
</script>

<style scoped>
.pt-45 {
  padding-top: 2rem !important;
}

#webpack-dev-server-client-overlay {
  display: none;
}
</style>
